
import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { FormGroup, FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { Tir } from "src/app/bo/tir";
import { BlastService } from "src/app/services/blast.service";

@Component({
  selector: 'app-blasted-status-modal',
  templateUrl: './blasted-status-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, FormsModule],
  standalone: true
})
export class BlastedStatusModalComponent{
    blast: Tir;
    blastDate = '';
    blastTime = '';
    
    constructor(
      private readonly dialogRef: MatDialogRef<BlastedStatusModalComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private readonly blastService: BlastService
    ) { }
    
    ngOnInit(): void {
      this.blast = this.data.blast;
      
      const now = new Date();
      this.blastDate = now.toISOString().split('T')[0];
      this.blastTime = now.toTimeString().split(' ')[0].substring(0, 5);
    }
    protected onClose(): void {
    this.dialogRef.close(false);
  }

      updateBlastedStatus() {
      if (!this.blastDate || !this.blastTime) {
        return;
      }
      
      const dateOnly = new Date(this.blastDate);
      const [hours, minutes] = this.blastTime.split(':').map(Number);
      
      this.blast.dateTirEffective = dateOnly;
      this.blast.dateTirEffective.setHours(hours);
      this.blast.dateTirEffective.setMinutes(minutes);
      this.blast.blasted = 1;
      
       this.blastService.markAsBlasted(this.blast.tirId, this.blast.dateTirEffective, true).subscribe({
        next: (response) => {
          this.blast.dateTirEffective = response.dateTirEffective;
          this.blast.blasted = response.blasted;
          this.dialogRef.close(this.blast);
        }
      });
  }
}   